import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const AGENT_PROCEDURES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('AGENT_PROCEDURES');
export const AGENT_PROCEDURES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	AGENT_PROCEDURES_CRUD_ACTION_CONSTANTS
);
